module.exports = __webpack_public_path__ + "img/top-bac.dbc492a1.png";